import FeaturePageTemplate from "@/components/features/FeaturePageTemplate";
import { renterFeatureGroups } from "@/content/publicFeatures";

export default function FeaturesRenters() {
  return (
    <FeaturePageTemplate
      audience="renter"
      eyebrow="ConfirmPH for renters"
      title="Know what the rental business actually recorded."
      intro="ConfirmPH gives renters a clearer path from discovery and confirmation to pickup, return, review, and repeat booking. The business still operates the rental; ConfirmPH keeps the shared record easier to review."
      groups={renterFeatureGroups}
      primaryCta={{ to: "/find-booking", label: "Check my booking" }}
      secondaryCta={{ to: "/rentals", label: "Discover rentals" }}
      seoTitle="ConfirmPH Features for Renters"
      seoDescription="Discover rentals, review secure booking details, request changes, track your rental record, and leave booking-linked reviews with ConfirmPH."
      canonical="/features/renters"
    />
  );
}
